import { FullPageSkeleton } from '@/components/ui/skeleton'

const PageNotFound = () => {
  return <FullPageSkeleton />
}

export default PageNotFound
